module.exports = __webpack_public_path__ + "static/media/fellowship_img2.88f4bbd6.png";